module.exports = __webpack_public_path__ + "static/media/Header-Image.efcbedf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Header-Image.jpg
// module id = 671
// module chunks = 21